#import "../../../../common/graphql/EntityDocumentsFields.graphql"

mutation EntityDocumentAppliedUpdate(
  $input: EntityDocumentAppliedUpdateInput!
) {
  entityDocumentAppliedUpdate(input: $input) {
    entityDocument {
      ...EntityDocumentsFields
    }
  }
}
